require('./zone-perturbe.scss');

import DemandeActions from '../../../../actions/demande.actions';
import { STEPS } from '../../../../utils/routes.util';

export default class ZonePerturbeComponent {
  constructor() {
    this.controller = ZonePerturbeController;
    this.template = require('./zone-perturbe.html');
  }
}

// @ngInject
class ZonePerturbeController {

  constructor($scope, $ngRedux) {
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
  }

  $onInit() {
    // Demande de récupération de la demande avant connexion au state
    this.$ngRedux.dispatch(DemandeActions.loadDemande(STEPS.ZONE_PERTURBE));
    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          data: state.demande.data.zonePerturbe ? state.demande.data.zonePerturbe.asMutable({deep: true}) : this.data
        };
      }
    )(this);

    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
  }

  // Actions
  prevStep() {
    this.$ngRedux.dispatch(DemandeActions.updateZonePerturbe(this.data, true));
  }
  nextStep(source) {
    this.data.source = source;
    this.$ngRedux.dispatch(DemandeActions.updateZonePerturbe(this.data));
  }
}



// WEBPACK FOOTER //
// ./src/modules/antenniste/components/zone-perturbe/zone-perturbe.component.js